function addTapEvent(ele, callback) {
    let tapStartTime = 0,
        tapEndTime = 0,
        //tap等待时间，在此事件下松开可触发方法
        tapTime = 500,
        tapStartClientX = 0,
        tapStartClientY = 0,
        tapEndClientX = 0,
        tapEndClientY = 0,
        //水平或垂直方向移动超过15px测判定为取消（根据chrome浏览器默认的判断取消点击的移动量)
        tapScollHeight = 15,
        cancleClick = false;
    ele.addEventListener('touchstart', function(e) {
        tapStartTime = e.timeStamp;
        const touch = e.changedTouches[0];
        tapStartClientX = touch.clientX;
        tapStartClientY = touch.clientY;
        cancleClick = false;
    });
    ele.addEventListener('touchmove', function(e) {
        const touch = e.changedTouches[0];
        tapEndClientX = touch.clientX;
        tapEndClientY = touch.clientY;
        if (
            Math.abs(tapEndClientX - tapStartClientX) > tapScollHeight ||
            Math.abs(tapEndClientY - tapStartClientY) > tapScollHeight
        ) {
            cancleClick = true;
        }
    });
    ele.addEventListener('touchend', function(e) {
        tapEndTime = e.timeStamp;
        if (!cancleClick && tapEndTime - tapStartTime <= tapTime) {
            callback(e);
        }
    });
}

function hasClass(elem, cls) {
    if (new RegExp(cls, 'g').test(elem.className)) {
        return true;
    }
    return false;
}

function addClass(ele, cls) {
    if (!hasClass(ele, cls)) {
        ele.className = ele.className == '' ? cls : ele.className + ' ' + cls;
    }
}

function removeClass(ele, cls) {
    if (hasClass(ele, cls)) {
        let newClass = ' ' + ele.className.replace(/[\t\r\n]/g, '') + ' ';
        while (newClass.indexOf(' ' + cls + ' ') >= 0) {
            newClass = newClass.replace(' ' + cls + ' ', ' ');
        }
        ele.className = newClass.replace(/^\s+|\s+$/g, '');
    }
}
/*
* 冒泡捕捉,delegate
* 例如:对body 内的符合某个condition 判定特征的dom 元素执行某个点击回调
* */
function bubble(elem, condition, callBack) {
    let con = false;
    do {
        if (condition(elem)) {
            con = true;
            break;
        } else {
            elem = elem.parentNode;
        }
    } while (elem.parentNode);
    con && callBack(elem);
}
function bubbleNegative(elem, condition, callBack) {
    let con = true;
    do {
        if (condition(elem)) {
            con = false;
            break;
        } else {
            elem = elem.parentNode;
        }
    } while (elem.parentNode);
    con && callBack(elem);
}

export { hasClass, addClass, removeClass, addTapEvent, bubble,bubbleNegative };
